/* BASIC APP CONSTANTS */
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const APP_COOKIE_NAME = "APP_COOKIE_NAME";
export const USER_COOKIE_NAME = "USER_COOKIE_NAME";
export const PASS_COOKIE_NAME = "PASS_COOKIE_NAME";
export const USER_ID_COOKIE_NAME = "USER_ID_COOKIE_NAME";
export const SET_CURRENT_ROUTE = "SET_CURRENT_ROUTE";
export const SET_SIDE_MENU_STATE = "SET_SIDE_MENU_STATE";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";
export const SHOW_ACTION_MENU = "SHOW_ACTION_MENU";
export const HIDE_ACTION_MENU = "HIDE_ACTION_MENU";
export const SHOW_BOTTOM_TOOLBAR = "SHOW_BOTTOM_TOOLBAR";
export const HIDE_BOTTOM_TOOLBAR = "HIDE_BOTTOM_TOOLBAR";
export const SET_USER_LIST = "SET_USER_LIST";
export const EDIT_DISABLED_BUTTONS = "EDIT_DISABLED_BUTTONS";
export const SET_LOGS_LIST = "SET_LOGS_LIST";
export const THEME = "THEME";

/* <---- BASIC APP CONSTANTS ----> */

/* SOCKET CONSTANTS */
export const CONNECTED = "connected";
export const DISCONNECTED = "disconnected";
/* <---- SOCKET CONSTANTS ----> */

/* CONFIGURATION */
export const CONFIGURATION_FORM_TOOGLE_LOADING =
  "CONFIGURATION_FORM_TOOGLE_LOADING";
export const SET_CONFIGURATION = "SET_CONFIGURATION";
/* <---- CONFIGURATION ----> */

/* USER */
export const SET_PROFILE = "SET_PROFILE";
/* <---- USER ----> */

/* USERS */
export const ADD_NEW_USER = "ADD_NEW_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const OPEN_USER_FORM = "OPEN_USER_FORM";
export const CLOSE_USER_FORM = "CLOSE_USER_FORM";
export const EDIT_SELECTED_USER = "EDIT_SELECTED_USER";
export const USERS_FORM_TOOGLE_LOADING = "USERS_FORM_TOOGLE_LOADING";
/* <---- USERS ----> */

/* RESPONSIBLE */
export const SET_RESPONSIBLE_LIST = "SET_RESPONSIBLE_LIST";
export const ADD_NEW_RESPONSIBLE = "ADD_NEW_RESPONSIBLE";
export const UPDATE_RESPONSIBLE = "UPDATE_RESPONSIBLE";
export const DELETE_RESPONSIBLE = "DELETE_RESPONSIBLE";
export const OPEN_RESPONSIBLE_FORM = "OPEN_RESPONSIBLE_FORM";
export const CLOSE_RESPONSIBLE_FORM = "CLOSE_RESPONSIBLE_FORM";
export const EDIT_SELECTED_RESPONSIBLE = "EDIT_SELECTED_RESPONSIBLE";
export const RESPONSIBLE_FORM_TOOGLE_LOADING = "RESPONSIBLE_FORM_TOOGLE_LOADING";
/* <---- RESPONSIBLE ----> */

/* REPORT */
export const SET_REPORT_LIST = "SET_REPORT_LIST";
export const ADD_NEW_REPORT = "ADD_NEW_REPORT";
export const UPDATE_REPORT = "UPDATE_REPORT";
export const DELETE_REPORT = "DELETE_REPORT";
export const OPEN_REPORT_FORM = "OPEN_REPORT_FORM";
export const CLOSE_REPORT_FORM = "CLOSE_REPORT_FORM";
export const EDIT_SELECTED_REPORT = "EDIT_SELECTED_REPORT";
export const REPORT_FORM_TOOGLE_LOADING = "REPORT_FORM_TOOGLE_LOADING";
/* <---- REPORT ----> */

/* OBJECT */
export const SET_OBJECT_LIST = "SET_OBJECT_LIST";
export const ADD_NEW_OBJECT = "ADD_NEW_OBJECT";
export const UPDATE_OBJECT = "UPDATE_OBJECT";
export const DELETE_OBJECT = "DELETE_OBJECT";
export const OPEN_OBJECT_FORM = "OPEN_OBJECT_FORM";
export const CLOSE_OBJECT_FORM = "CLOSE_OBJECT_FORM";
export const EDIT_SELECTED_OBJECT = "EDIT_SELECTED_OBJECT";
export const OBJECT_FORM_TOOGLE_LOADING = "OBJECT_FORM_TOOGLE_LOADING";
/* <---- OBJECT ----> */

/* UBICATION */
export const SET_UBICATION_LIST = "SET_UBICATION_LIST";
export const ADD_NEW_UBICATION = "ADD_NEW_UBICATION";
export const UPDATE_UBICATION = "UPDATE_UBICATION";
export const DELETE_UBICATION = "DELETE_UBICATION";
export const OPEN_UBICATION_FORM = "OPEN_UBICATION_FORM";
export const CLOSE_UBICATION_FORM = "CLOSE_UBICATION_FORM";
export const EDIT_SELECTED_UBICATION = "EDIT_SELECTED_UBICATION";
export const UBICATION_FORM_TOOGLE_LOADING = "UBICATION_FORM_TOOGLE_LOADING";
/* <---- UBICATION ----> */

/* ZONE */
export const SET_ZONE_LIST = "SET_ZONE_LIST";
export const ADD_NEW_ZONE = "ADD_NEW_ZONE";
export const UPDATE_ZONE = "UPDATE_ZONE";
export const DELETE_ZONE = "DELETE_ZONE";
export const OPEN_ZONE_FORM = "OPEN_ZONE_FORM";
export const CLOSE_ZONE_FORM = "CLOSE_ZONE_FORM";
export const EDIT_SELECTED_ZONE = "EDIT_SELECTED_ZONE";
export const ZONE_FORM_TOOGLE_LOADING = "ZONE_FORM_TOOGLE_LOADING";
/* <---- ZONE ----> */

/* ROUTES */
export const SET_ALL_ROUTES = "SET_ALL_ROUTES";
export const UPDATE_ROUTE = "UPDATE_ROUTE";
/* <---- ROUTES ----> */

/* ALERT */
export const SET_ALERT_LIST = "SET_ALERT_LIST";
export const ADD_NEW_ALERT = "ADD_NEW_ALERT";
export const UPDATE_ALERT = "UPDATE_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";
export const OPEN_ALERT_FORM = "OPEN_ALERT_FORM";
export const CLOSE_ALERT_FORM = "CLOSE_ALERT_FORM";
export const EDIT_SELECTED_ALERT = "EDIT_SELECTED_ALERT";
export const ALERT_FORM_TOOGLE_LOADING = "ALERT_FORM_TOOGLE_LOADING";
/* <---- ALERT ----> */
